import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import WCTHero from "./components/WCTHero";
import WCTContent from "./components/WCTContent";
import WCTShopSection from "./components/WCTShopSection";
import WCTFormula from "./components/WCTFormula";
import WCTRelated from "./components/WCTRelated";
import WCTBottomCTA from "./components/WCTBottomCTA";

export default function WoodCoffeeTablesPage() {
  return (
    <div className="min-h-screen bg-[#FDFAF5]" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <main>
        <WCTHero />
        <div className="max-w-screen-xl mx-auto px-8 md:px-16">
          <WCTContent />
          <WCTShopSection />
          <WCTFormula />
        </div>
        <WCTRelated />
        <WCTBottomCTA />
      </main>
      <Footer />
    </div>
  );
}
